export enum ArquivoPrincipalEnum {
    INICIO = 'INICIO',
    FINAL = 'FINAL',
}
